import { Textarea } from 'braid-design-system';
import type { QuestionProps } from '../../type';
import { EXPERIMENT_TWO_TEXT_MAX_LENGTH } from '../../validation/validationRules';

export const WorkingEnvironmentDetailsQuestion = ({
  value = '',
  message = '',
  tone,
  onChange,
}: QuestionProps) => {
  return (
    <Textarea
      id="workingEnvironmentDetails"
      label="How would you describe the space, amenities, and facilities?"
      onChange={(event) => onChange(event.currentTarget.value)}
      value={value}
      tone={tone}
      message={message}
      reserveMessageSpace
      characterLimit={EXPERIMENT_TWO_TEXT_MAX_LENGTH}
    />
  );
};
